import { Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import AISparkles from '@/components/common/AISparkles';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import { Button } from '@/components/shadcn/button';

export default function AnalysisNotInsurance() {
  const { t } = useTranslation();
  const {
    analysis: { triage },
    forceAnalyze,
  } = useEmail();

  return (
    <div className="flex w-full flex-col gap-1 rounded-md border p-2">
      <p className="text-foreground flex items-center gap-1 text-xs font-bold">
        <Mail className="text-primary-500 size-4 shrink-0" />

        {t(`TRIAGE_${triage.classification}_TITLE`)}
      </p>

      <div className="flex flex-col items-start gap-2">
        <div className="text-muted-foreground text-xs">{t('TRIAGE_OTHER')}</div>

        <Button variant="secondary" size="sm" onClick={forceAnalyze}>
          <AISparkles className="text-inherit" />

          {t('ANALYZE_ANYWAY')}
        </Button>
      </div>
    </div>
  );
}
